import {Col, ColProps} from "antd";

export default function BBBChartColContainer(colProps: ColProps) {
    return <Col
        xs={24}
        xl={12}
        xxl={8}
        {...colProps} />
}